import React from 'react';
import AuthCardLayout from 'layouts/AuthCardLayout';

const PasswordReset = () => {
  return (
    <AuthCardLayout>
      <h3>Reset password</h3>
    </AuthCardLayout>
  );
};

export default PasswordReset;
